export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    message?: string,
    public issues?: unknown,
  ) {
    super(message ?? code);
  }
}

export async function api<T>(
  method: string,
  path: string,
  body?: unknown,
): Promise<T> {
  const res = await fetch(path, {
    method,
    credentials: 'same-origin',
    headers: body ? { 'content-type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : {};
  if (!res.ok) {
    throw new ApiError(res.status, data.error ?? 'error', data.message, data.issues);
  }
  return data as T;
}
